(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intracoastal-carousel"] && !Shopify.designMode) return;
  try {
    
  // Shared by every <ic-carousel> on the site — Featured Products, Deals'
  // grid, and each Category Strip row all use this one definition.
  class IcCarousel extends HTMLElement {
    connectedCallback() {
      this.track   = this.querySelector('[data-ic-track]');
      this.prevBtn = this.querySelector('[data-ic-prev]');
      this.nextBtn = this.querySelector('[data-ic-next]');
      if (!this.track) return;
      this.bindEvents();
      this.updateEdges();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.track.scrollBy({ left: -(this.track.clientWidth * 0.8), behavior: 'smooth' });
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.track.scrollBy({ left: this.track.clientWidth * 0.8, behavior: 'smooth' });
        });
      }
      this.track.addEventListener('scroll', () => this.updateEdges(), { passive: true });
      window.addEventListener('resize', () => this.updateEdges(), { passive: true });
    }

    // Arrow state plus the edge-fade hint. The fade is what tells the visitor
    // there is more content off the side — the job the auto-pan used to do,
    // without any ambient motion. Same mask technique as .ic-pill-nav__track.
    updateEdges() {
      const atStart = this.track.scrollLeft <= 1;
      const atEnd   = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;

      const overflows = this.track.scrollWidth > this.track.clientWidth + 4;
      this.track.classList.toggle('ic-carousel__track--fade-start', overflows && !atStart);
      this.track.classList.toggle('ic-carousel__track--fade-end',   overflows && !atEnd);
    }

  }

  if (!customElements.get('ic-carousel')) {
    customElements.define('ic-carousel', IcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intracoastal-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intracoastal-pill-nav"] && !Shopify.designMode) return;
  try {
    
  class IcPillNav extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-sticky')) return;

      this._fixed = false;
      this._naturalTop = null;

      this._spacer = document.createElement('div');
      this._spacer.setAttribute('aria-hidden', 'true');
      this._spacer.style.cssText = 'display: none;';
      this.after(this._spacer);

      this._ro = new ResizeObserver(() => {
        this._spacer.style.height = this.offsetHeight + 'px';
      });
      this._ro.observe(this);

      this._scrollHandler = () => this._check();
      this._resizeHandler = () => { this._naturalTop = null; this._check(); };

      window.addEventListener('scroll', this._scrollHandler, { passive: true });
      window.addEventListener('resize', this._resizeHandler, { passive: true });

      requestAnimationFrame(() => this._check());
    }

    _check() {
      var headerHeight = parseFloat(document.body.style.getPropertyValue('--header-height')) || 60;

      if (this._naturalTop === null) {
        var ref = this._fixed ? this._spacer : this;
        this._naturalTop = ref.getBoundingClientRect().top + window.scrollY;
      }

      var shouldFix = window.scrollY >= this._naturalTop - headerHeight;

      if (shouldFix === this._fixed) return;

      this._fixed = shouldFix;
      this.classList.toggle('ic-pill-nav--fixed', shouldFix);
      this._spacer.style.display = shouldFix ? 'block' : 'none';

      if (!shouldFix) this._naturalTop = null;
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      if (this._spacer) this._spacer.remove();
      window.removeEventListener('scroll', this._scrollHandler);
      window.removeEventListener('resize', this._resizeHandler);
    }
  }

  if (!customElements.get('ic-pill-nav')) {
    customElements.define('ic-pill-nav', IcPillNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intracoastal-wave"] && !Shopify.designMode) return;
  try {
    
  // Scroll parallax for the layered wave crests. One shared rAF-throttled
  // listener drives every wave on the page — the previous version bound a
  // separate un-throttled scroll handler per section and called
  // getBoundingClientRect() on every single scroll event.
  (function () {
    if (window.__icWaveBound) return;
    window.__icWaveBound = true;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let queued = false;

    function update() {
      queued = false;
      document.querySelectorAll('.ic-wave').forEach((el) => {
        const speed = parseFloat(el.dataset.waveSpeed || '8');
        if (!speed) return;
        const rect = el.getBoundingClientRect();
        // Skip anything off screen — no layout work for waves nobody sees.
        if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
        const progress = ((rect.top + rect.height / 2) / window.innerHeight) - 0.5;
        el.querySelectorAll('[data-wave-layer]').forEach((layer) => {
          const depth = parseFloat(layer.dataset.waveLayer) || 1;
          layer.style.transform =
            'translateX(' + (progress * speed * 2 * depth).toFixed(2) + 'px)';
        });
      });
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    if (!reduce) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    update();
  }());

  } catch(e) { console.error(e); }
})();
})();
